

















































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import Loading from '@/app/ui/components/Loading/index.vue'
import controller from '@/app/ui/controllers/PayrollController'
import { PeriodRule, Tier } from '@/domain/entities/Payroll'
import { EventBus, EventBusConstants, LocalStorage } from '@/app/infrastructures/misc'
import PayrollTextInput from '../../../components/PayrollTextInput/index.vue'

interface Options {
  label: string
  value: string
}

interface IRule {
  [k: string]: Options | Array<ITier> | undefined
}

interface ITier {
  minWeight: number
  multiplyType?: Options
  fee: number
  parkingFee: number
}

@Component({
  components: {
    DropdownSelect,
    Loading,
    PayrollTextInput
  },
})

export default class BasicFeePage extends Vue {
  controller = controller
  currentPeriod = ''
  basicFeeId = ''
  modalConfirmVisible = false
  modalConfirmDeleteVisible = false
  modalSuccessVisible = false
  isValidate = false
  selectedRuleIndex = 0

  calcMethodOptions: Array<Options> = []
  productOptions: Array<Options> = []
  multiplyOptions: Array<Options> = []

  ruleData: Array<IRule> = []

  created(): void {
    EventBus.$on(EventBusConstants.EDIT_PERIOD_BASIC_FEE_SUCCESS, (response: boolean) => {
      if (response) {
        this.modalSuccessVisible = true
        this.fetchData()
        controller.setIsChanged(false)
      }
    })

    this.currentPeriod = LocalStorage.getLocalStorage('selectedPeriod')
    this.fetchData()
  }

  get filteredProductTypeOpt(): Array<Options> {
    const selectedProduct = this.ruleData.map((rd) => rd.productType)
    return this.productOptions.filter((cm) => !selectedProduct.includes(cm))
  }

  private getHeaders(tierType: string) {
    const headers = [
      'Berat Minimal',
      'Type (KG/FLAT)',
    ]

    if (tierType === 'pickup') {
      headers.push('Pick Up Fee')
      headers.push('Pick Up Fee - Parking')
    } else if (tierType === 'delivery') {
      headers.push('Delivery Fee')
      headers.push('Delivery Fee - Parking')
    }

    return headers
  }

  private fetchData() {
    controller.getDetail(this.$route.params.periodId)
  }

  private generateOptions(list: string[], labelFormat: string) {
    const res = list.map(method => {
      let label = method

      if (labelFormat === 'capitalize')
        label = `${label.charAt(0).toUpperCase()}${label.substring(1)}`
      if (labelFormat === 'uppercase') label = label.toUpperCase()

      return {
        label: label,
        value: method,
      }
    })

    return res
  }

  private tierMapper(tierData: Array<Tier>) {
    return (tierData as Array<Tier>).map((tier) => {
      return {
        fee: tier.fee || 0,
        minWeight: tier.minWeight || 0,
        parkingFee: tier.parkingFee || 0,
        multiplyType:
          this.multiplyOptions.find(
            opt => opt.value === tier.multiplyType
          ) || undefined,
      }
    })
  }

  @Watch('controller.dataPeriodRule')
  setDataPeriodRule(data: PeriodRule): void {
    this.ruleData = []
    const basicFee = data.basicFee

    if (data.basicFeeId) {
      this.basicFeeId = String(data.basicFeeId)
    }

    if (basicFee?.calculationMethod) {
      this.calcMethodOptions = this.generateOptions(
        basicFee?.calculationMethod,
        'capitalize'
      )
    }

    if (basicFee?.productType) {
      this.productOptions = this.generateOptions(
        basicFee?.productType,
        'capitalize'
      )
    }

    if (basicFee?.multiplyType) {
      this.multiplyOptions = this.generateOptions(
        basicFee?.multiplyType,
        'uppercase'
      )
    }

    if (basicFee?.rules) {
      const basicFeeRules = basicFee.rules as Array<
        Record<string, string | Array<Tier>>
      >

      basicFeeRules.forEach(rule => {
        const deliveryTier: Array<ITier> = this.tierMapper(rule.deliveryTier as Array<Tier>)
        const pickupTier: Array<ITier> = this.tierMapper(rule.pickupTier as Array<Tier>)

        const res: IRule = {
          calculationMethod:
            this.calcMethodOptions.find(
              opt => opt.value === rule.calculationMethod
            ),
          deliveryTier: deliveryTier,
          pickupTier: pickupTier,
          productType:
            this.productOptions.find(opt => opt.value === rule.productType) ||
            undefined,
        }
        this.ruleData.push(res)
      })
    }
  }
}
